exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accordion__item[data-v-9c3b849a]{cursor:pointer;position:relative}.accordion-enter-active[data-v-9c3b849a],.accordion-leave-active[data-v-9c3b849a]{will-change:height,opacity;transition:height .3s ease,opacity .3s ease}.accordion-enter[data-v-9c3b849a],.accordion-leave-to[data-v-9c3b849a]{height:0!important;opacity:0}", ""]);

// exports
